import {Environment, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import * as tracking from '../../tracking';
import {trackAndCommitMutation} from '../../tracking/amplitude/TrackMutation';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';
import {
	DeleteCustomFieldDropdownOptionInput,
	DeleteCustomFieldDropdownOptionMutation,
} from './__generated__/DeleteCustomFieldDropdownOptionMutation.graphql';
import type {Disposable} from 'relay-runtime';

const mutation = graphql`
	mutation DeleteCustomFieldDropdownOptionMutation($input: DeleteCustomFieldDropdownOptionInput!) {
		deleteCustomFieldDropdownOption(input: $input) {
			clientMutationId
			deletedOptionId
			replacementOptionId
		}
	}
`;

function getOptimisticResponse(input: DeleteCustomFieldDropdownOptionInput) {
	return {
		deletedOptionId: input.optionId,
		replacementOptionId: input.replacementOptionId,
	};
}

function commit(
	environment: Environment,
	input: MutationInput<DeleteCustomFieldDropdownOptionInput>,
	onSuccess: RelayOnCompleted<DeleteCustomFieldDropdownOptionMutation>,
	onError: RelayOnError
): Disposable {
	tracking.trackEvent('CustomFieldDefinitionDropdownOption - Deleted');

	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		configs: [],
		onCompleted: onSuccess,
		onError: onError,
		optimisticResponse: getOptimisticResponse(input),
	});
}

export default {commit};
